<template>
    <div>
        <el-result icon="warning" title="404提示" sub-title="你找的页面不存在，点击下方按钮回家~">
            <template #extra>
                <el-button type="primary" @click="$router.push('/')">回到home页</el-button>
            </template>
        </el-result>
    </div>
</template>